import { FC } from "react"
import { FormattedMessage } from "react-intl"
import { Heading, P } from "shared/styles/textStyles"
import styled from "styled-components"

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.theme.colors.neutral};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: ${(props) => props.theme.font.primary};

  ${Heading} {
    font-size: 1.71rem;
    margin-top: 0;
  }

  ${P} {
    width: 70%;
    font-size: 1.43rem;
    line-height: 1.5;
    text-align: center;
  }
`

const ErrorMessage: FC<{ children?: JSX.Element }> = ({ children }) => (
  <Wrapper>
    <Heading>
      <FormattedMessage
        id="defaultErrorTitle"
        defaultMessage="Something went wrong."
      />
    </Heading>
    <P>
      {children ?? (
        <FormattedMessage
          id="defaultError"
          defaultMessage="Try refreshing the page."
        />
      )}
    </P>
  </Wrapper>
)

export default ErrorMessage
